import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
initSentry();
import App from "./App";
import "./index.css";
import { i18nReady } from "./i18n";

window.dispatchEvent(new CustomEvent("plate-os:startup-stage", { detail: "language" }));
i18nReady
  .catch((err) => {
    console.error("[i18n] init failed; rendering with English fallback", err);
  })
  .finally(() => {
    window.dispatchEvent(new CustomEvent("plate-os:startup-stage", { detail: "render" }));
    createRoot(document.getElementById("root")!).render(<App />);
  });
